import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=ea0f8e10&scoped=true"
import script from "./Records.vue?vue&type=script&lang=js"
export * from "./Records.vue?vue&type=script&lang=js"
import style0 from "./Records.vue?vue&type=style&index=0&id=ea0f8e10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0f8e10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea0f8e10')) {
      api.createRecord('ea0f8e10', component.options)
    } else {
      api.reload('ea0f8e10', component.options)
    }
    module.hot.accept("./Records.vue?vue&type=template&id=ea0f8e10&scoped=true", function () {
      api.rerender('ea0f8e10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/islamicFinance/Records.vue"
export default component.exports